import type {
  UpdateShareableProfileSettingsInput,
  UpdateApproachabilityInput,
} from '@seek/ca-graphql-schema/types';

import type { UpdateProfileVisibilityInput } from 'src/types/graphql';

const UpdateShareableProfileSettingsPayload = {
  __resolveType: (arg0: any) => arg0.__typename,
};

const Mutation = {
  updateProfileVisibility: (
    _: unknown,
    { input }: { input: UpdateProfileVisibilityInput },
  ) => {
    if (input.level === 'Limited') {
      return new Error(); // Mocked to show error toast for "Limited" option
    }
    return {
      viewer: {
        id: 34712547,
        profileVisibility: {
          level: input.level,
          description: input.level,
        },
      },
    };
  },

  updateApproachability: (
    _: unknown,
    { input }: { input: UpdateApproachabilityInput },
  ) => ({
    viewer: {
      id: 34712547,
      approachability: input,
    },
  }),

  updateShareableProfileSettings: (
    _: unknown,
    { input }: { input: UpdateShareableProfileSettingsInput },
  ) => ({
    __typename: 'UpdateShareableProfileSettingsSuccess',
    viewer: {
      id: 34712547,
      shareableProfileSettings: {
        active: input.active,
      },
    },
  }),
};

export { UpdateShareableProfileSettingsPayload, Mutation };
